import React from 'react'

import { useFetchList } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import AllocationHistory from 'models/AllocationHistory'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

import styles from './HistoryDialog.module.sass'
import NoData from 'components/general/NoData/NoData'

const CoordinatorHistoryRow = (props) => {
	const { data, i18n } = props
	const { previousCoordinator, coordinator, ruleName, modificationDate } =
		data

	return (
		<HStack
			className={styles['history-row']}
			gap='small'
			justify='space-between'
		>
			<VStack>
				<small>
					<strong>{modificationDate?.dateTimeFormat || '-'}</strong>
				</small>
			</VStack>
			<HStack className={styles['state-column']} align='center'>
				<small>
					<strong
						className={`${styles['coordinator']} ${
							previousCoordinator?.name
								? styles['--previous']
								: styles['--no-coordinator']
						}`}
					>
						{previousCoordinator?.name ||
							i18n`No previous coordinator`}
					</strong>
				</small>
				<small>
					<strong>→</strong>
				</small>
				<small>
					<strong className={styles['coordinator']}>
						{coordinator?.name}
					</strong>
				</small>
			</HStack>
			<VStack>
				<small>
					<strong>{i18n.translate(ruleName) || '-'}</strong>
				</small>
			</VStack>
		</HStack>
	)
}

const CoordinatorHistoryDialog = (props) => {
	const { data } = props
	const { processId, selectedTab } = data
	const { i18n } = useGlobal()

	const {
		contents: [allocationHistory],
		state,
	} = useFetchList(
		[`/clinical_processes/${processId}/coordinator_allocation_history`],
		[AllocationHistory.fromJSON]
	)

	const filtered = allocationHistory
		?.filter((item) => item?.coordinatorType === selectedTab)
		.sort((a, b) => b.id - a.id)

	const isLoading = state === 'loading'
	return !isLoading ? (
		filtered?.length ? (
			<VStack className={styles['history-container']}>
				{(filtered || []).map((coordinatorHistoryItem, key) => (
					<CoordinatorHistoryRow
						key={key}
						data={coordinatorHistoryItem}
						i18n={i18n}
					/>
				))}
			</VStack>
		) : (
			<NoData
				applyMaxWidth
				paddings={['normal', 'normal']}
				message={i18n`This process has no extra data to show.`}
			/>
		)
	) : (
		<VStack className={styles['center-content']} justify='space-between'>
			<Icon name='on-going' />
			<small>{i18n`Loading coordinator history...`}</small>
		</VStack>
	)
}

export default CoordinatorHistoryDialog
